import script from "./ThankYou.vue?vue&type=script&setup=true&lang=js"
export * from "./ThankYou.vue?vue&type=script&setup=true&lang=js"

import "./ThankYou.vue?vue&type=style&index=0&id=7965ddd7&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7965ddd7"]])

export default __exports__